import { AxiosRequestConfig } from 'axios';

import {
  WorkItemType,
} from '../../../sdk/src/shared';
import { BASE_API } from '../utils';
import { ExerciseSkill } from '../shared';

export type ExerciseType = Exclude<WorkItemType, 'Folder'>;

interface BaseExercise {
  name: string;
  skills: ExerciseSkill[];
  type: ExerciseType;
}

export interface Assignment extends BaseExercise {
  id: number;
  classes: number;
  pointsToFinish: number;
  spiralReviewPoints: number;
  type: 'Assignment';
}

// id is for saved ExamTemplates, unsavedIdentifier is for unsaved ExamTemplates
export interface ExamTemplate extends BaseExercise {
  id?: number;
  static: boolean;
  // unique string to identify unsaved exam templates
  unsavedIdentifier?: string;
  type: 'ExamTemplate';
}

export type Exercise = Assignment | ExamTemplate;

// ALL OPTIONAL
interface PdfParams {
  format?: 'pdf';
  problemsPerSkill?: number;
  shuffle?: boolean;
  versions?: number;
  exact?: boolean;
  includeAnswerKey?: boolean;
}

interface ShowConfig extends AxiosRequestConfig {
  method: 'GET';
  params: Omit<PdfParams, 'format'>;
  url: `/exercises/${string}.pdf` | `/exercises/${string}`;
}

/**
 * GET /v1/exercises/{id}
 * OR
 * GET /v1/exercises/{id[.pdf]}
 */
export const show = (
  id: string,
  { format, ...params }: PdfParams = {},
): ShowConfig => {
  const url =
    format === 'pdf'
      ? (`/exercises/${id}.pdf` as const)
      : (`/exercises/${id}` as const);

  return {
    baseURL: BASE_API,
    method: 'GET',
    params,
    url,
  };
};
